import { createContext } from "react";

export type ResourceListApi = {
  incrementRefreshIndex: () => void;
  hasAppliedFilter: (filterName: string) => boolean;
  removeAppliedFilter: (filterName: string) => void;
  addAppliedFilter: (
    filterName: string,
    params: {
      value: any;
      operator: string;
    },
  ) => void;
};

export type ResourceListContextValue = {
  api: ResourceListApi;
};
export const ResourceListContext =
  createContext<null | ResourceListContextValue>(null);
